module.exports = __webpack_public_path__ + "img/Coronabot.62d483f2.png";